module.exports = __webpack_public_path__ + "img/vector-3.f26c729a.svg";